// src/utils/RoleManager.ts
export type UserRole = 'master' | 'clubAdmin' | 'coach' | 'parent';

export const canView = {
  players: (role: UserRole) => ['master', 'clubAdmin', 'coach'].includes(role),
  schedule: (role: UserRole) => ['master', 'clubAdmin', 'coach'].includes(role),
  messages: (role: UserRole) => ['master', 'clubAdmin', 'coach'].includes(role),
  payments: (role: UserRole) => ['master', 'clubAdmin'].includes(role),
  teamManagement: (role: UserRole) => ['master', 'clubAdmin'].includes(role),
  userManagement: (role: UserRole) => ['master'].includes(role),
  settings: (role: UserRole) => ['master', 'clubAdmin'].includes(role),
};
